<template>
  <div class="research_group_container" v-if="researchGroupCharacter === 'leader' || customerNo === displayChosenResearchGroup.accountCustomerNo">
    <div class="hd research-background-color">
      <span class="icon icon-left navshare" @click="goBack" v-if="!isWapp"></span>
      <span class="header_title">对账单</span>
    </div>
    <div v-if="billInfo">
      <div v-if="monthOrYear !== 'all'" :class="{'box': showBillConfirmButton, 'no-footer-box': !showBillConfirmButton}">
        <div class="bd_1">
          <div class="outer_1">
            <div :class="{'wrap': true, 'research-background-color': monthOrYear==='month'}">
              <span :class="{'notChosenBill': monthOrYear!=='month', 'chosenBill': monthOrYear==='month'}" @click="chooseBillType('month')">月度账单</span>
              <svg v-if="monthOrYear==='month'" class="arrow-down" width="6.5vw" height="6.5vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z" fill="#ffffff" /></svg>
            </div>
            <div :class="{'wrap': true, 'research-background-color': monthOrYear==='year'}">
              <span :class="{'notChosenBill': monthOrYear!=='year', 'chosenBill': monthOrYear==='year'}" @click="chooseBillType('year')">年度账单</span>
              <svg v-if="monthOrYear==='year'" class="arrow-down" width="6.5vw" height="6.5vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z" fill="#ffffff" /></svg>
            </div>
            <div :class="{'wrap': true, 'research-background-color': monthOrYear==='all'}">
              <span :class="{'notChosenBill': monthOrYear!=='all', 'chosenBill': monthOrYear==='all'}" @click="chooseBillType('all')">累计账单</span>
            </div>
          </div>
          <div>
            <div class="block_2">
              <div class="moneyWrap">
                <span class="clock">{{displayDate}}账单金额</span>
                <span class="money research-font-color">¥{{summary.billAmount && splitMoney(summary.billAmount.toFixed(2))}}</span>
              </div>
              <div class="moneyWrap">
                <span class="clock">{{displayDate}}未清金额</span>
                <span class="money research-font-color">¥{{summary.balanceAmount && splitMoney(summary.balanceAmount.toFixed(2))}}</span>
              </div>
            </div>
            <div class="block_2" style="margin-bottom: 6vw;">
              <div class="moneyWrap">
                <span class="clock">{{displayDate}}消费金额</span>
                <span class="money research-font-color">¥{{summary.consumedMoneySum && splitMoney(summary.consumedMoneySum.toFixed(2))}}</span>
              </div>
              <div class="moneyWrap">
                <span class="clock">{{displayDate}}交付金额</span>
                <span class="money research-font-color">¥{{summary.deliveryMoneySum && splitMoney(summary.deliveryMoneySum.toFixed(2))}}</span>
              </div>
            </div>
          </div>
        </div>
        <BillList :billInfo="billInfo" :top="0"/>
      </div>
      <!--累计账单-->
      <div v-else :class="{'box': showBillConfirmButton, 'no-footer-box': !showBillConfirmButton}">
        <div class="bd_1">
          <div class="outer_1">
            <div :class="{'wrap': true, 'research-background-color': monthOrYear==='month'}">
              <span :class="{'notChosenBill': monthOrYear!=='month', 'chosenBill': monthOrYear==='month'}" @click="chooseBillType('month')">月度账单</span>
              <svg v-if="monthOrYear==='month'" class="arrow-down" width="6.5vw" height="6.5vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z" fill="#ffffff" /></svg>
            </div>
            <div :class="{'wrap': true, 'research-background-color': monthOrYear==='year'}">
              <span :class="{'notChosenBill': monthOrYear!=='year', 'chosenBill': monthOrYear==='year'}" @click="chooseBillType('year')">年度账单</span>
              <svg v-if="monthOrYear==='year'" class="arrow-down" width="6.5vw" height="6.5vw" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M127.947776 279.937024L486.395904 743.875584c0 0 25.55392 25.778176 51.207168 0 40.80640001-41.105408 358.449152-442.91072 358.449152-463.93753599-25.201664-25.35424-51.207168 0-51.207168-1e-8L512 692.31616l-332.845056-412.379136C179.154944 279.937024 153.14944 254.582784 127.947776 279.937024z" fill="#ffffff" /></svg>
            </div>
            <div :class="{'wrap': true, 'research-background-color': monthOrYear==='all'}">
              <span :class="{'notChosenBill': monthOrYear!=='all', 'chosenBill': monthOrYear==='all'}" @click="chooseBillType('all')">累计账单</span>
            </div>
          </div>
          <div>
            <div class="block_2">
              <div class="moneyWrap">
                <span class="clock">{{displayDate}}开票金额</span>
                <span class="money research-font-color">¥{{summary.invoiceMoneySum && splitMoney(summary.invoiceMoneySum.toFixed(2))}}</span>
              </div>
              <div class="moneyWrap">
                <span class="clock">{{displayDate}}支付金额</span>
                <span class="money research-font-color">¥{{summary.invoiceReceivedMoneySum && splitMoney(summary.invoiceReceivedMoneySum.toFixed(2))}}</span>
              </div>
            </div>
            <div class="block_2" style="margin-bottom: 6vw;">
              <div class="moneyWrap">
                <span class="clock">{{displayDate}}消费金额</span>
                <span class="money research-font-color">¥{{summary.consumedMoneySum && splitMoney(summary.consumedMoneySum.toFixed(2))}}</span>
              </div>
              <div class="moneyWrap">
                <span class="clock">{{displayDate}}交付金额</span>
                <span class="money research-font-color">¥{{summary.deliveryMoneySum && splitMoney(summary.deliveryMoneySum.toFixed(2))}}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="yearList.length>0" class="bd_2">
          <div class="submain" @click="showAnnualBill(year)" v-for="year in yearList">
            <span class="consumptionDetails">{{year}}年账单</span>
            <div class="CenRadioIconWrap_2">
              <svg t="1583809028111" class="liveiconput" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1461" width="200" height="200"><path d="M279.937024 896.052224L743.875584 537.604096c0 0 25.778176-25.55392 0-51.207168-41.105408-40.80640001-442.91072-358.449152-463.93753599-358.449152-25.35424 25.201664 0 51.207168-1e-8 51.207168L692.31616 512l-412.379136 332.845056C279.937024 844.845056 254.582784 870.85056 279.937024 896.052224z" fill="#929292" p-id="1462"></path></svg>
            </div>
          </div>
        </div>
      </div>
      <div class="ft" v-if="showBillConfirmButton">
        <div class="col1" @click="sendEmail"><span class="tag">联系我们</span></div>
        <div class="col2 research-background-color" @click="submit" v-if="!billInfo.status"><span class="tag_2">确认账单</span></div>
        <div class="col3" v-else><span class="tag_2">已核对</span></div>
      </div>
    </div>
    <div v-else>
      <img src="/static/img/对账单空.png" style="width: 100%;margin-top: 150px;">
    </div>
    <ChooseBillPeriod :defaultYear="year" :defaultMonth="month" :monthOrYear="monthOrYear" v-if="showChooseBillPeriod" @getBillInfo="getBillInfo" @toggleShow="showChooseBillPeriod=!showChooseBillPeriod"/>
    <ResearchGroupRemindBox :remindParams="remindParams" v-if="showResearchGroupRemindBox" @toggleShow="toggleResearchGroupRemindBox"/>
    <AnnualBillDetail v-if="showAnnualBillDetail" :billInfo="annualBillInfo" @toggleShow="showAnnualBillDetail=!showAnnualBillDetail"/>

  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import $ from 'jquery'
import EMKT from '../../../../emkt'
// import BillDetail from './BillDetail'
import BillList from './BillList'
import AnnualBillDetail from './AnnualBillDetail'
import ChooseBillPeriod from './ChooseBillPeriod'
import ResearchGroupRemindBox from './../researchGroupComponents/ResearchGroupRemindBox'

export default {
  data () {
    return {
      billInfo: EMKT.getLocalStorage('billInfo'),
      deliverIsOpen: false,
      consumeIsOpen: false,
      showBillDetail: false,
      showChooseBillPeriod: false,
      contractInfo: {},
      type: '',
      monthOrYear: 'month',
      remindParams: {
        firstline: '',
        secondline: '',
        singleOrDouble: 1
      },
      showResearchGroupRemindBox: false,
      yearList: [],
      annualContractObj: {},
      showAnnualBillDetail: false,
      annualBillInfo: {},
      year: new Date().getFullYear(),
      month: new Date().getMonth() < 10 ? '0' + new Date().getMonth() : new Date().getMonth()
    }
  },
  mounted () {

  },
  components: {
    BillList, ChooseBillPeriod, ResearchGroupRemindBox, AnnualBillDetail
  },
  computed: {
    ...mapGetters([
      'displayChosenResearchGroup', 'researchGroupCharacter', 'customerNo', 'isWapp'
    ]),
    summary () {
      if (!this.billInfo) return {}
      return this.billInfo.summary
    },
    consumeContractList () {
      if (!this.billInfo) return {}
      return this.billInfo.consumeContractList
    },
    deliverContractList () {
      if (!this.billInfo) return {}
      return this.billInfo.deliverContractList
    },
    invoiceList () {
      if (!this.billInfo) return {}
      return this.billInfo.invoiceList
    },
    showBillConfirmButton () {
      return this.billInfo && this.billInfo.statementGuid && this.monthOrYear === 'month'
    },
    displayDate () {
      if (this.monthOrYear === 'month') {
        return this.year + '年' + this.month + '月'
      }
      if (this.monthOrYear === 'year') {
        return this.year + '年'
      }
      if (this.monthOrYear === 'all') return '历史累计'
    }
  },
  methods: {
    goBack () {
      this.$router.push({name: 'ResearchGroupHome'})
    },
    splitMoney (moneyNumber) {
      if (moneyNumber === undefined) {
        return ''
      }
      return String(moneyNumber).replace(/\B(?=(?:\d{3})+\b)/g, ',')
    },
    showBillInfo (detail, type) {
      this.contractInfo = detail
      this.type = type
      this.showBillDetail = !this.showBillDetail
      console.log('detail', detail)
    },
    getBillInfo (params) {
      if (String(params).includes('-')) {
        this.year = String(params).split('-')[0]
        this.month = String(params).split('-')[1]
      } else if (params) {
        this.year = String(params)
      }
      // let parameter = '00000013,' + params // '00000026,2018-11'
      let parameter = this.displayChosenResearchGroup.researchGroupNo + ',' + params
      console.log('params->' + parameter)
      this.gcapi('loadResearchGroupBillInfo', parameter).then((res) => {
        // console.log('res.body.result：', JSON.parse(res.body.result))
        var mes = JSON.parse(res.body.result)
        if (!mes.result) {
          $.toast('课题组编号不存在')
          return
        }
        const obj = JSON.parse(JSON.parse(res.body.result).json)
        console.log('账单对象：', obj)
        this.billInfo = obj
        if (this.monthOrYear === 'all') {
          this.classifyBillByYear()
          EMKT.setStoreItem('allBillInfo', obj)
        } else {
          EMKT.setStoreItem('billInfo', obj)
        }
      })
    },
    classifyBillByYear () {
      const list1 = this.billInfo.consumeContractList
      const list2 = this.billInfo.deliverContractList
      const annualContractObj = {}
      for (let i of list1) {
        let year = i.contractStartDT.substring(0, 4)
        if (!annualContractObj[year]) {
          annualContractObj[year] = {}
          // annualContractObj[year].isSelected = false
          annualContractObj[year].year = year
          annualContractObj[year].consumeContractList = []
          annualContractObj[year].consumeContractList.push(i)
        } else if (!annualContractObj[year].consumeContractList) {
          annualContractObj[year].consumeContractList = []
          annualContractObj[year].consumeContractList.push(i)
        } else {
          annualContractObj[year].consumeContractList.push(i)
        }
      }
      for (let j of list2) {
        let year = j.deliveryDT.substring(0, 4)
        if (!annualContractObj[year]) {
          annualContractObj[year] = {}
          // annualContractObj[year].isSelected = false
          annualContractObj[year].year = year
          annualContractObj[year].deliverContractList = []
          annualContractObj[year].deliverContractList.push(j)
        } else if (!annualContractObj[year].deliverContractList) {
          annualContractObj[year].deliverContractList = []
          annualContractObj[year].deliverContractList.push(j)
        } else {
          annualContractObj[year].deliverContractList.push(j)
        }
      }
      this.yearList = Object.keys(annualContractObj)
      this.annualContractObj = annualContractObj
    },
    chooseBillType (type) {
      if (type === 'all') {
        this.monthOrYear = 'all'
        if (!EMKT.getLocalStorage('allBillInfo')) return this.getBillInfo('')
        this.billInfo = EMKT.getLocalStorage('allBillInfo')
        this.classifyBillByYear()
        return
      }
      if (type === 'month') {
        this.showChooseBillPeriod = !this.showChooseBillPeriod
        this.monthOrYear = 'month'
        return
      }
      if (type === 'year') {
        this.showChooseBillPeriod = !this.showChooseBillPeriod
        this.monthOrYear = 'year'
        return
      }
    },
    sendEmail () {
      this.gcapi('contactUsForBill', this.billInfo.statementGuid
      ).then((response) => {
        this.billInfo.status = 2
        this.remindParams.firstline = '您的反馈已收到'
        this.remindParams.secondline = '我们将会尽快联系您。'
        this.toggleResearchGroupRemindBox()
        // $.alert('您的反馈已收到，我们将会尽快联系您，感谢您对吉凯基因的支持。')
      })
    },
    submit () {
      this.gcapi('confirmBill', this.billInfo.statementGuid
      ).then((response) => {
        if (response.body.code === 0) {
          this.billInfo.status = 1
          this.remindParams.firstline = '感谢您对吉凯基因的支持'
          this.remindParams.secondline = ''
          this.toggleResearchGroupRemindBox()
          // $.toast('感谢您对吉凯基因的支持!')
        }
      })
    },
    toggleResearchGroupRemindBox () {
      this.showResearchGroupRemindBox = !this.showResearchGroupRemindBox
    },
    showAnnualBill (year) {
      this.annualBillInfo = this.annualContractObj[year]
      console.log('annualBillInfo', this.annualBillInfo)
      this.showAnnualBillDetail = !this.showAnnualBillDetail
    }
  }
}
</script>
<style scoped>
.research_group_container {
  overflow-y:auto;
  overflow-x:hidden;
  height:100%;
}
.box {
  /*display: flex;*/
  position: absolute;
  /*align-items: center;*/
  /*flex-direction: column;*/
  background-color: #efeef3;
  width: 100vw;
  height: calc(100vh - 40vw);
  overflow: scroll;
  top: 14.93vw;
}
.no-footer-box {
  /*display: flex;*/
  position: relative;
  /*align-items: center;*/
  /*flex-direction: column;*/
  background-color: #efeef3;
  width: 100vw;
  height: 100vh;
  top: 14.93vw;
  padding-bottom: 30vw;
}
.hd {
  display: flex;
  position: fixed;
  top:0;
  left:0;
  align-items: center;
  flex-direction: row;
  /*background-color: #5878fa;*/
  width: 100vw;
  height: 14.93vw;
  z-index: 10;
  justify-content: center;
}

.hd {
  display: flex;
  position: fixed;
  top:0;
  left:0;
  align-items: center;
  flex-direction: row;
  /*background-color: #5878fa;*/
  width: 100vw;
  height: 14.93vw;
  z-index: 10;
  justify-content: center;
}


.navshare {
  position: absolute;
  left: 6.67vw;
  width: 10vw;
  height: 10vw;
  padding-top: 2vw;
  color:#ffffff;
}
.header_title {
  opacity: 1;
  /*margin-left: 29.33vw;*/
  max-width: 60.53vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 4.27vw;
  font-weight: 400;
}
.header_title {
  opacity: 1;
  /*margin-left: 29.33vw;*/
  max-width: 60.53vw;
  height: 5.87vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 4.27vw;
  font-weight: 400;
}

.bd_1 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  /*margin-left: auto;*/
  /*margin-right: auto;*/
  margin: 6.67vw auto;
  margin-bottom: 0;
  border-radius: 2.67vw;
  background-color: #ffffff;
  width: 86.67vw;
  /* height: 37.33vw; */
  /*flex-shrink: 0;*/
}
.bd_2 {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin: 0 auto;
  border-radius: 2.67vw;
  /*background-color: #ffffff;*/
  width: 86.67vw;
  /* height: 37.33vw; */
  /*flex-shrink: 0;*/
}

.tag {
  opacity: 1;
  text-align: center;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.2vw;
  font-weight: 400;
}

.outer_1 {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  border-radius: 2.67vw;
  background-color: #e7e7e7;
  width: 86.67vw;
  height: 7.47vw;
}

.wrap {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: row;
  border-radius: 2.67vw;
  /*background-color: #5878fa;*/
  padding-right: 3.2vw;
  padding-left: 8vw;
  height: 7.47vw;
  width: 33.4%;
}

.chosenBill {
  opacity: 1;
  width: 12.8vw;
  height: 7.47vw;
  text-align: center;
  line-height: 7.47vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.2vw;
  font-weight: 400;
}

.arrow-down {
  margin-left: 1.2vw;
  width: 3vw;
  /*height: 1.87vw;*/
}

.notChosenBill {
  opacity: 1;
  /*margin-top: 1.6vw;*/
  /*margin-left: 8.27vw;*/
  /*width: 12.8vw;*/
  /*height: 4.53vw;*/
  text-align: center;
  line-height: 7.47vw;
  height: 7.47vw;
  white-space: nowrap;
  color: #979797;
  font-size: 3.2vw;
  font-weight: 400;
  width: 33%;
}

.block_2 {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 7vw;
  padding-right: 6.4vw;
  padding-left: 6.67vw;
  width: 86.67vw;
  height: 7vw;
}

.moneyWrap {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 42.93vw;
  height: 10.4vw;
}

.clock {
  opacity: 1;
  max-width: 40vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #979797;
  font-size: 3.2vw;
  font-weight: 400;
}

.money {
  opacity: 1;
  max-width: 40vw;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 5.87vw;
  white-space: nowrap;
  /*color: #5878fa;*/
  font-size: 4.27vw;
  font-weight: 500;
}



.submain {
  box-sizing: border-box;
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 6.67vw;
  border-radius: 2.67vw;
  background-color: #ffffff;
  padding-right: 6.4vw;
  padding-left: 6.67vw;
  width: 86.67vw;
  height: 13.33vw;
  flex-shrink: 0;
}

.consumptionDetails {
  opacity: 1;
  width: 12.8vw;
  height: 4.53vw;
  line-height: 4.53vw;
  white-space: nowrap;
  color: #424242;
  font-size: 3.2vw;
  font-weight: 500;
}

.CenRadioIconWrap_2 {
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  width: 4.27vw;
  height: 4.27vw;
}


.ft {
  position: fixed;
  bottom: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  /*margin-top: 58.67vw;*/
  padding-right: 6.13vw;
  padding-left: 6.67vw;
  box-shadow: 0px 0px 104px rgba(0, 0, 0, 0.13);
  background-color: #ffffff;
  width: 99.73vw;
  height: 25vw;
}

.col1 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.67vw;
  background-color: #ff9400;
  width: 40vw;
  height: 13.33vw;
}

.tag {
  opacity: 1;
  max-width: 36.8vw;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.73vw;
  font-weight: 400;
}

.col2 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.67vw;
  /*background-color: #5878fa;*/
  width: 40vw;
  height: 13.33vw;
}
.col3 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border-radius: 2.67vw;
  background-color: #979797;
  width: 40vw;
  height: 13.33vw;
}
.tag_2 {
  opacity: 1;
  max-width: 36.8vw;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  line-height: 5.33vw;
  white-space: nowrap;
  color: #ffffff;
  font-size: 3.73vw;
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// BillCheck.vue?5b29e59a